// extracted by mini-css-extract-plugin
module.exports = {"newsViewRoot":"SBpVrX2l","leftContent":"y1CGSVuv","rightContent":"EcNzRmCf","listTitle":"I9sOB57x"};